import Vue from "vue";
import App from "./App.vue";
import VueAMap from "vue-amap";
import router from "./router/config.js";
import store from "./store/index.js";
import "@/static/js/rem.js"
import './viewhcss/viewh.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import "./static/js/rem"
import { Lazyload } from 'vant'
Vue.use(Vant);
Vue.use(Lazyload)
// 兼容
import "babel-polyfill";            // 兼容IE8以上版本

//引入vue-quill-editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, {
  placeholder: '请输入内容',
});

Vue.prototype.jsonData = (data) => {
    var json = {};
    data.map(item => {
        for(var attr in item) {
            json[attr] = item[attr];
        }
    });
    return json;
};

import moment from 'moment';
Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)

})

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);


import vucIdentify from "vuc-identify";
Vue.use(vucIdentify);

import "font-awesome/css/font-awesome.min.css";

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: "6c310a022e8e0c932cb8627570d29af5",
    plugin: [
        "AMap.Autocomplete",    // 输入提示插件
        "AMap.PlaceSearch",     // POI查询插件
        "AMap.Scale",           // 右下角缩略图插件 比例尺
        "AMap.OverView",        // 地图鹰眼插件
        "AMap.ToolBar",         // 地图工具条
        "AMap.MapType",         // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        "AMap.PolyEditor",      // 编辑 折线多，边形
        "AMap.CircleEditor",    // 圆形编辑器插件
        "AMap.Geolocation",     // 定位控件，用来获取和展示用户主机所在的经纬度位置
    ],
    v: "1.4.4",                 // 版本
});

import VConsole from 'vconsole'
const isProd = process.env.NODE_ENV === 'production'
if (!isProd) {
  const vConsole = new VConsole()
  Vue.use(vConsole)
}

Vue.config.productionTip = false;
Vue.config.devtools = false;

new Vue({
    el: "#app",
    router: router,
    store,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js